import { Card, Grid } from '@mui/material';
import React from 'react';
import { WsColors, WsButton, WsTypography, WsTypoVariants } from 'wisestep-base';

export interface IBulkAssignCard {
  icon: React.ReactElement;
  name: string;
  onClick?: React.MouseEventHandler;
}

const BulkAssignCard = ({ icon, name, onClick }: IBulkAssignCard) => (
  <Card variant="outlined" square sx={{ borderRadius: 2, alignContent: 'center' }}>
    <Grid container p={4} spacing={2}>
      <Grid
        item
        bgcolor={WsColors.TertiaryShades50}
        xs={3}
        m={1}
        borderRadius={2}
        border="1px solid #EAEAF1"
      >
        {icon}
      </Grid>
      <Grid item xs={8} alignContent="flex-start">
        <WsTypography variant={WsTypoVariants.SUB_TITLE}>{name}</WsTypography>
      </Grid>
      <Grid item xs={12}>
        <WsButton
          fullWidth
          onClick={onClick}
          variant="outlined"
          size="large"
          disabled={name === 'Partners'}
        >
          {name === 'Partners' ? 'Coming Soon' : 'Assign'}
        </WsButton>
      </Grid>
    </Grid>
  </Card>
);
export default BulkAssignCard;
